import {defineMessages} from "@project/i18n";

export const customerOfferFieldLabelIds = {
  language: "fields.customerOffer.language",
  currency: "fields.customerOffer.currency",
  content: "fields.customerOffer.content",
  status: "fields.customerOffer.status",
  name: "fields.customerOffer.name",
} as const;
export const customerOfferFieldMessages = defineMessages({
  language: {
    id: "fields.customerOffer.language",
    defaultMessage: "Language",
    description: "CustomerOffer semantic field label for language",
  },
  currency: {
    id: "fields.customerOffer.currency",
    defaultMessage: "Currency",
    description: "CustomerOffer semantic field label for currency",
  },
  content: {
    id: "fields.customerOffer.content",
    defaultMessage: "Content",
    description: "CustomerOffer semantic field label for content",
  },
  status: {
    id: "fields.customerOffer.status",
    defaultMessage: "Status",
    description: "CustomerOffer semantic field label for status",
  },
  name: {
    id: "fields.customerOffer.name",
    defaultMessage: "Offer number",
    description: "CustomerOffer semantic field label for name",
  },
});
export const customerOfferValidationMessages = defineMessages({
  duplicateIdentity: {
    id: "validation.customerOffer.duplicateIdentity",
    defaultMessage: "This identity already exists in its content scope.",
    description: "Reject duplicate content identities or scope-local variable names",
  },
});
